import { ArrowRightIcon } from "lucide-react";

export type ISectionTitle = {
    title: string
}

export const SectionTitleH1 = ({title} : ISectionTitle) => {
    return (
        <h1 className="p-2 border-b-2">
            <ArrowRightIcon className="inline" /> {title}
        </h1>
    )
}
export const SectionTitle = ({title} : ISectionTitle) => {
    return (
        <h2 className="text-2xl font-bold mb-2 py-2">
            {title}
        </h2>
    )
}